import jump from 'jump.js';
import m from 'mithril';
var Router = /** @class */ (function () {
    function Router(initialState) {
        this.transport = null;
        this.data = {};
        this.data = initialState;
    }
    Router.prototype.url = function () {
        return this.data.url;
    };
    Router.prototype.view = function (vnode) {
        var href = window.location.href;
        var params = href.indexOf('?') > -1 ? m.parseQueryString(href.split('?')[1]) : {};
        var route = { href: href, path: window.location.pathname, params: params };
        return this.resolve(this.data, route);
    };
    Router.prototype.mount = function (element) {
        var _this = this;
        window.onpopstate = function (e) {
            if (e.state) {
                _this.setData(e.state.data);
                m.redraw();
            }
            else {
                _this.navigate(window.location.pathname);
            }
        };
        m.mount(element, this);
    };
    Router.prototype.getPageTitle = function (data) {
        return data.title;
    };
    Router.prototype.setData = function (data) {
        this.data = data;
        var _a = window.location, hash = _a.hash, href = _a.href;
        var queryIndex = href.indexOf('?');
        var query = queryIndex > -1 ? href.substr(queryIndex) : '';
        window.history.replaceState({ data: data }, this.getPageTitle(data));
        document.title = this.getPageTitle(data);
    };
    Router.prototype.clear = function () {
        if (!this.transport)
            return;
        this.transport.abort();
        this.transport = null;
    };
    Router.prototype.scroll = function (hash) {
        if (hash)
            jump(hash);
        else
            window.scrollTo(0, 0);
    };
    Router.prototype.fetch = function (path) {
        return Promise.reject('implement');
    };
    Router.prototype.resolve = function (data, route) {
        throw 'implement';
    };
    Router.prototype.navigate = function (path) {
        var _this = this;
        var hash = window.location.hash;
        if (path == this.url()) {
            if (hash)
                this.scroll(hash);
        }
        else {
            this.clear();
            return this.fetch(path).then(function (data) {
                _this.setData(data);
                setTimeout(function () { return _this.scroll(hash); });
                return data;
            });
        }
    };
    return Router;
}());
export { Router };
